module.exports = __webpack_public_path__ + "static/media/Linkedin_icon.62fce863.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Linkedin_icon.svg
// module id = 31
// module chunks = 0